import { render, staticRenderFns } from "./SharedShortlistsHeader.vue?vue&type=template&id=717b6ac0&"
import script from "./SharedShortlistsHeader.vue?vue&type=script&lang=js&"
export * from "./SharedShortlistsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports